import React, { useEffect } from 'react';
import { SeoBar } from '../components/SeoBar';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { HeroSection } from './industry-news/HeroSection';
import { PlaceholderSection } from './industry-news/PlaceholderSection';
export function IndustryNewsPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-3113">
      <SeoBar data-id="element-3114" />
      <Header data-id="element-3115" />
      <main className="flex-grow" data-id="element-3116">
        <div className="w-full bg-gray-50 pb-20" data-id="element-3117">
          <HeroSection data-id="element-3118" />
          <PlaceholderSection data-id="element-3119" />
        </div>
      </main>
      <Footer data-id="element-3120" />
    </div>;
}